import { Component } from '@angular/core';

@Component({
  selector: 'atr-site-footer',
  standalone: true,
  template: `
    <footer class="site-footer">
      <div class="footer-main">
        <div class="footer-brand">
          <p>Hand-focused interior and exterior detailing for Bushnell, IL and the surrounding area.</p>
          <p class="footer-note">Koch Chemie products, safe wash methods, and appointment-based care.</p>
        </div>

        <div class="footer-column">
          <h2>Services</h2>
          <span>Interior detailing</span>
          <span>Exterior detailing</span>
          <span>Full details</span>
          <span>Mobile detailing</span>
        </div>

        <div class="footer-column footer-contact">
          <h2>Contact</h2>
          <a href="tel:+13093355423">309-335-5423</a>
          <a href="mailto:atr2982@gmail.com">atr2982@gmail.com</a>
          <span>529 W Main Street</span>
          <span>Bushnell, IL 61422</span>
        </div>
      </div>

      <div class="footer-bottom">
        <span>ATR Automotive Detailing</span>
        <span>Evening and weekend availability. Mobile appointments upon request.</span>
      </div>
    </footer>
  `,
})
export class SiteFooterComponent {}
